export default class BlockSliderMultiple {
	constructor() {
		let blocks = document.querySelectorAll('.block-slider-multiple');

		blocks.forEach(block => {
			const swiper = block.querySelector(".swiper");
			const swiperPagination = block.querySelector(".swiper-custom-pagination-fraction");
			const prev = block.querySelector(".navigation-button-prev");
			const next = block.querySelector(".navigation-button-next");
			const fmt = n => n < 10 ? '0' + n : n;

			const slider = new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: true,
				navigation: {
					prevEl: prev,
					nextEl: next,
				}
			});

			const updatePagination = () => {
				swiperPagination.innerHTML = `<span class="swiper-pagination-current">${fmt(slider.realIndex + 1)}</span> / <span>${fmt(slider.slides.length)}</span>`;
			};

			updatePagination();
			slider.on('slideChange', updatePagination);
		});
	}
}
